<div class="grid align-items-center">
  <div class="breadcrumb col-12 md:col">
    <h3>Lista magazzini</h3>
  </div>
  <!-- <div class="add col-12 md:col-3 text-left md:text-right">
    <a pButton
      routerLink="/main/magazzini/aggiungi-magazzino"
      class="butt p-button-rounded"
      *hasGrants="['WAREHOUSE.D']"><span>Aggiungi Magazzino</span></a>
  </div> -->
</div>

<div class="grid align-items-center">
  <div class="col-8">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="dt1.filterGlobal([keywordFilter.value, typeFilter.value], '')"
        placeholder="Cerca..." />
    </span>
  </div>
  <div class="col-3">
    <p-multiSelect
      (onChange)="dt1.filterGlobal([keywordFilter.value, typeFilter.value], '')"
      #typeFilter
      placeholder="Filtra per tipo..."
      [options]="type"
      optionLabel="name"
      optionValue="id"
      styleClass="w-full"
      [formControl]="selectedMulti"
      [displaySelectedLabel]="true"
      [emptyMessage]="'Nessun risultato trovato'"></p-multiSelect>
  </div>
  <div class="col">
    <p-button
      styleClass="butt w-full"
      icon="pi pi-filter-slash"
      (click)="clear(dt1)"
      pTooltip="Elimina filtri"
      tooltipPosition="top"></p-button>
  </div>
</div>
<div class="tbl max-w-full">
  <p-table
    [value]="sites"
    dataKey="id"
    #dt1
    [paginator]="true"
    [rows]="rowsPerPageOptions[0]"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadSites($event)"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Nome</th>
        <th>Tipo</th>
        <th>Indirizzo</th>
        <!-- <th></th> -->
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-d>
      <tr>
        <td>
          <p-radioButton
            [value]="d"
            [inputId]="d.id"
            name="selectedWarehouse"
            [formControl]="selectedWarehouseControl"></p-radioButton>
        </td>
        <td>
          {{ d.name }}
        </td>
        <td>
          <div *ngFor="let n of d.related_office_type">
            <span>{{ n.type.name }}</span>
          </div>
        </td>
        <td>
          {{ d.address }}
        </td>
        <!-- <td class="text-right white-space-nowrap">
          <a pButton
            *hasGrants="['WAREHOUSE.U']"
            pTooltip="Modifica"
            tooltipPosition="bottom"
            icon="pi pi-pencil"
            class="butt mx-3 p-button-rounded"
            [routerLink]="['modifica', d.id]"></a>
          <p-button
            *hasGrants="['WAREHOUSE.D']"
            pTooltip="Elimina"
            tooltipPosition="bottom"
            icon="pi pi-times"
            styleClass="butt mx-3"
            (click)="showDialog(d, $event)"
            [rounded]="true"
          ></p-button>
        </td> -->
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="4"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
